import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './plugins/custom-icons';
import './plugins/vue-json-pretty';
import './plugins/bootstrap';
import './plugins/vuelidate';
import './plugins/vue2-daterange-picker';
import i18n from './i18n';
// bootstraping
import Bootstraping from './bootstrap'
Vue.use(Bootstraping)
// --------------
Vue.config.productionTip = false;
new Vue({
  name: 'cp-detect-portal',
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

